import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="16258" id="hero-anfrage-starten" className="relative w-full min-h-[90vh] flex flex-col lg:flex-row overflow-hidden bg-background text-foreground">
      <div className="absolute top-[-10%] left-[-10%] w-[40vw] h-[40vw] rounded-lg bg-primary/5 blur-[100px] pointer-events-none" />
      <div className="absolute bottom-[-10%] right-[40%] w-[30vw] h-[30vw] rounded-lg bg-secondary/10 blur-[80px] pointer-events-none" />

      <div className="w-full flex items-center justify-center relative z-10">
        <div ref={textRef} className={`w-full flex flex-col items-start justify-center transition-all duration-1000 ease-out bg-cover bg-center bg-no-repeat bg-[url(https://erzwerk-logistik.de/wp-content/uploads/2026/07/Hintergrund-Kontakt.png)] overflow-hidden relative min-h-[90vh] ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <div className="absolute inset-0 bg-black/40 z-0 transition-all duration-500" />

          <div className="relative z-10 max-w-7xl mx-auto w-full px-6 md:px-12 lg:px-16">
            <h1 className="font-serif font-bold uppercase tracking-tight text-white mb-8 transition-all duration-1000 delay-300 translate-y-0 opacity-100 !text-[50px] lg:leading-[1.1]">Ihre Fracht,<br />unsere Aufgabe</h1>
            
            <p className={`font-sans text-lg md:text-xl text-white/90 leading-relaxed max-w-2xl mb-10 transition-all duration-1000 delay-500 ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
              Ihr Partner für professionelle Kurierfahrten, sichere Antiquitätentransporte und reibungslose Umzüge. Wir bewegen Ihre Werte mit höchster Sorgfalt und Präzision.
            </p>

            <div className={`flex flex-wrap gap-4 transition-all duration-1000 delay-700 ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
              <Button asChild className="h-14 px-8 rounded-sm text-lg font-medium text-primary-foreground bg-primary hover:opacity-90 hover:scale-105 transition-all duration-300 shadow-md border-none">
                <Link to="/ContactRequestPage">
                  Jetzt anfragen <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <Button asChild variant="outline" className="inline-flex items-center justify-center gap-2 whitespace-nowrap disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border shadow-xs hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 py-2 has-[>svg]:px-3 h-14 px-8 rounded-sm text-lg font-medium border-white/20 text-white hover:bg-white/10 transition-all duration-300 bg-background/36">
                <Link to="/CourierExpressTripsPage">
                  Unsere Leistungen
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}